/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import BasicInformation from './BasicInformation/index'
import Comms from './Comms/index'
import Contact from './Contact/index'
import ExternalProfessionals from './ExternalProfessionals/index'
import OtherRelatives from './OtherRelatives/index'
import PatientComms from 'DesignSystem/PatientComms/index'
import PracticeHubAccountStatus from './PracticeHubAccountStatus/index'
import ProfilePicture from './ProfilePicture/index'
import React from 'react'
import ResponsibleRelatives from './ResponsibleRelatives/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let patientPersonValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person',
})
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfilePicture
  viewPath={`${viewPath}/ProfilePicture`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical1}`}
>
<BasicInformation
  viewPath={`${viewPath}/BasicInformation`}
/>
<Contact
  viewPath={`${viewPath}/Contact`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-2-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<PatientComms
 viewPath={viewPath}
 data="patient.person"
 person={patientPersonValueData}
 data="patient._id"
 patient_id={patientIdValueData}
>
{childProps => (
<Comms
{...childProps}
  viewPath={`${viewPath}/Comms`}
/>
)}
</PatientComms>
</div>
</div>
</div>
<PracticeHubAccountStatus
  viewPath={`${viewPath}/PracticeHubAccountStatus`}
/>
<ResponsibleRelatives
  viewPath={`${viewPath}/ResponsibleRelatives`}
/>
<OtherRelatives
  viewPath={`${viewPath}/OtherRelatives`}
/>
<ExternalProfessionals
  viewPath={`${viewPath}/ExternalProfessionals`}
/>
</div>
{children}
</React.Fragment>)
}